import config from '@/config';

/**
 * Authentication Utilities
 * Helper functions for managing authentication tokens and user data
 */

// Token Management
export const getAccessToken = () => {
  return localStorage.getItem(config.storage.accessToken);
};

export const setTokens = (accessToken) => {
  localStorage.setItem(config.storage.accessToken, accessToken);
};

export const clearTokens = () => {
  localStorage.removeItem(config.storage.accessToken);
};

// User Data Management
export const getUser = () => {
  const userStr = localStorage.getItem(config.storage.user);
  try {
    return userStr ? JSON.parse(userStr) : null;
  } catch {
    return null;
  }
};

export const setUser = (user) => {
  localStorage.setItem(config.storage.user, JSON.stringify(user));
};

export const clearUser = () => {
  localStorage.removeItem(config.storage.user);
};

// Combined Operations
export const clearAuth = () => {
  clearTokens();
  clearUser();
};

export const isAuthenticated = () => {
  return !!getAccessToken();
};

/**
 * Decode JWT token
 */
export const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

/**
 * Check if token is expired
 */
export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};

export default {
  getAccessToken,
  setTokens,
  clearTokens,
  getUser,
  setUser,
  clearUser,
  clearAuth,
  isAuthenticated,
};
